import { Box, Image, Stack, Text } from '@mantine/core';
import PropTypes from 'prop-types';
import React from 'react';

const TestSeal = ({
  size,
  label,
  icon,
  evaluation,
  evaluationDescription,
  ...rest
}) => (
  <Stack
    align="center"
    {...rest}
    sx={(theme) => ({
      border: `1px solid ${theme.colors.primary[theme.primaryShade as any]}`,
      borderRadius: 6,
    })}
    c="primary"
    bg="white"
  >
    {!label ? null : (
      <Text
        w="100%"
        weight={700}
        ta="center"
        size="xs"
        py={5}
        px={size}
        sx={(theme) => ({
          borderBottom: `1px solid ${theme.colors.primary[theme.primaryShade as any]}`,
        })}
      >
        {label}
      </Text>
    )}
    {!icon ? null : (
      <Box sx={{ width: size === 'sm' ? '33%' : '50%' }}>
        <Image {...icon} />
      </Box>
    )}
    <Box ta="center" py={size} px={size}>
      <Text weight={700} size="xl" sx={{ lineHeight: 1 }}>
        {evaluation}
      </Text>
      <Text weight={300} size="sm" sx={{ lineHeight: 1 }}>
        {evaluationDescription}
      </Text>
    </Box>
  </Stack>
);

TestSeal.propTypes = {
  size: PropTypes.oneOf(['sm', 'md']),
  label: PropTypes.string,
  icon: PropTypes.shape(Image.propTypes),
  evaluation: PropTypes.number,
  evaluationDescription: PropTypes.string,
};

TestSeal.defaultProps = {
  size: 'sm',
  label: null,
  icon: null,
  evaluation: null,
  evaluationDescription: null,
};

export default TestSeal;
